import {ChangeDetectionStrategy, Component, computed, inject, input, signal} from "@angular/core";
import {BringozToastService} from "../../../../commons/services/bringoz-toast.service";
import {SplitService} from "../../../../commons/services/split-service.service";

@Component({
  selector: "app-threepl-service-link",
  templateUrl: "./threepl-service-link.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplServiceLinkComponent {
  readonly serviceId = input<string>();
  readonly externalId = input<string>();

  private readonly displayExternal = inject<SplitService>("splitService" as never).getSiteExternalIdConfig();
  private readonly toast = inject<BringozToastService>("bringozToastService" as never);

  readonly hovered = signal(false);

  readonly displayId = computed(() =>
    this.externalId() && this.displayExternal ? this.externalId() : this.serviceId());

  readonly params = computed(() => ({id: this.serviceId()}));

  onCopied(): void {
    this.toast.success({body: "TEXT_COPIED_TO_CLIPBOARD"});
  }
}
